module.exports = __webpack_public_path__ + "static/media/Phone.0f9a9d49.svg";